import React, { useState } from 'react';
import './FeedbackModal.css';
import usePatientStore from '../../store/usePatientStore';
import useSurgicalStore from '../../store/useSurgicalStore';

const FeedbackModal = ({ onClose, onSave, isSurgical = false }) => {
  const [feedback, setFeedback] = useState('');
  const { consultationId } = usePatientStore()
  const { surgicalId } = useSurgicalStore()

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (feedback.trim()) {
      onSave(feedback);
      await sendFeedback(feedback)
    }
  };

  const sendFeedback = async ( feedback_content) => {
    let bodyData = {}
    if (isSurgical) {
      bodyData = {
        "is_surgical": true,
        "is_consultation": false,
        "session_id": surgicalId,
        "feedback_content": feedback_content
      }
    }
    else{
      bodyData = {
        "is_surgical": false,
        "is_consultation": true,
        "session_id": consultationId,
        "feedback_content": feedback_content
      }
    }


    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        },
        body: JSON.stringify(bodyData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to submit feedback');
      }

      const result = await response.json();
      console.log('Feedback submitted successfully:', result);
      return result;
    } catch (error) {
      console.error('Error submitting feedback:', error.message);
    }
  };


  return (
    <div className="feedback-modal-overlay">
      <div className="feedback-modal">
        <h2>Feedback</h2>
        <form onSubmit={handleSubmit}>
          <textarea
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Enter your feedback here..."
            required
          />
          <div className="feedback-modal-buttons">
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancel
            </button>
            <button type="submit" className="save-btn">
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackModal;
